const CLIENTS = [
    "Novaetrics",
    "Bayside Dental Group",
    "Luma Interiors",
    "Kaplan Legal Group",
    "Velo Freight",
    "Bright Harbor Realty",
    "Solstice Wellness",
    "Pierpoint Capital",
];

const Row = () => (
    <>
        {CLIENTS.map((c) => (
            <div key={c} className="flex items-center gap-12 shrink-0">
                <span className="font-display font-bold uppercase tracking-widest text-xl text-white/35 whitespace-nowrap">
                    {c}
                </span>
                <span className="w-2 h-2 rotate-45 bg-gold/50 shrink-0" />
            </div>
        ))}
    </>
);

export default function ClientMarquee() {
    return (
        <div
            data-testid="client-logos-marquee"
            className="marquee-wrap relative bg-navy-deep border-y border-gold/15 py-8 overflow-hidden"
        >
            <div className="animate-marquee flex w-max items-center gap-12 px-6">
                <Row />
                <Row />
            </div>
        </div>
    );
}
